import { getCategoryById } from "./categories";
import { defaultFormBase } from "./components/VideoForm";
/**
 * Choose a model id that is valid for the target Video Studio category.
 * @param {import("./categories").VideoStudioCategory | undefined} category
 * @param {{ model_ids?: string[] }} libraryItem
 */
export function pickModelForLibraryItem(category, libraryItem) {
  const allowed = category?.modelIds || [];
  const candidates = libraryItem.model_ids || [];
  const match = candidates.find((id) => allowed.includes(id));
  return match || candidates[0] || category?.defaultModelId || "kling-3.0";
}

/**
 * @param {string} categoryId
 * @param {{ title?: string, prompt?: string, use_case?: string | null, model_ids?: string[] }} libraryItem
 */
export function buildFormFromLibraryItem(categoryId, libraryItem) {
  const category = getCategoryById(categoryId);
  const modelId = pickModelForLibraryItem(category, libraryItem);
  const base = defaultFormBase(category);
  const promptText = String(libraryItem.prompt || "").trim();

  /** @type {ReturnType<typeof defaultFormBase>} */
  const form = {
    ...base,
    model: modelId,
    title: String(libraryItem.title || "").trim(),
    prompt: promptText,
  };

  return form;
}

/**
 * @param {{ use_case?: string | null, modelId?: string, prompt?: string, title?: string }} opts
 */
export function buildVideoStudioUrl(opts) {
  const params = new URLSearchParams();
  params.set("page", "video-studio");
  if (opts.use_case) params.set("use_case", opts.use_case);
  if (opts.modelId) params.set("model", opts.modelId);
  if (opts.prompt) params.set("prompt", opts.prompt);
  if (opts.title) params.set("prompt_title", opts.title);
  return `/user?${params.toString()}`;
}

/**
 * Parse library-related query params from the current URL.
 * @returns {{ use_case: string, model: string, prompt: string, prompt_title: string } | null}
 */
export function readLibraryParamsFromSearch() {
  const params = new URLSearchParams(window.location.search);
  const prompt = params.get("prompt");
  const use_case = params.get("use_case");
  if (!prompt && !use_case) return null;
  return {
    use_case: use_case || "",
    model: params.get("model") || "",
    prompt: prompt || "",
    prompt_title: params.get("prompt_title") || "",
  };
}

/**
 * Remove library prefill params from the URL (keeps page=video-studio and job=).
 */
export function clearLibraryParamsFromUrl() {
  const params = new URLSearchParams(window.location.search);
  params.delete("prompt");
  params.delete("prompt_title");
  params.delete("model");
  params.delete("use_case");
  const qs = params.toString();
  const path = `${window.location.pathname}${qs ? `?${qs}` : ""}`;
  window.history.replaceState({}, "", path);
}

/**
 * Navigate to Video Studio with a library item prefilled.
 * @param {{ title?: string, prompt?: string, use_case?: string | null, model_ids?: string[] }} item
 */
export function openInVideoStudio(item) {
  const use_case =
    item.use_case && getCategoryById(item.use_case) ? item.use_case : "text-to-video";
  const category = getCategoryById(use_case);
  const modelId = pickModelForLibraryItem(category, item);
  window.location.assign(
    buildVideoStudioUrl({
      use_case,
      modelId,
      prompt: item.prompt,
      title: item.title,
    }),
  );
}
